export const imageAddresses = [
  'https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/game-of-thrones-illustration-sean-longmore-1598631176.jpeg?crop=0.669xw:1.00xh;0.0896xw,0&resize=640:*',
  'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/4909/474909-h',
  'http://www.nattyponline.com/wp-content/uploads/2019/05/jonsnowonthronegot.jpg',
  'https://ychef.files.bbci.co.uk/976x549/p01wzkmh.jpg',
  'https://pyxis.nymag.com/v1/imgs/62c/f92/e4547dee01b62de2a417c06a6f5f8fc5ab-02-got-gluekit.rsocial.w1200.jpg',
  'https://microdestek.com.tr/wp-content/uploads/2017/08/Game-of-Thrones-Season-6-HEADER.jpg',
  'https://www.pluggedin.com/wp-content/uploads/2020/01/GoT3_Large-1024x587.jpg',
  'https://i.insider.com/5cad1b8702d9a10279396b54?width=743&format=jpeg',
  'https://deadline.com/wp-content/uploads/2019/09/courtesy-of-hbo-game-of-thrones-season-6-2-e1569193549549.jpg'
];

export const charImgAddresses = [
  {
    name: 'Robert I Baratheon',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/robert-baratheon-1920.jpg?w=1200'
  },
  {
    name: 'Tyrion Lannister',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/tyrion-lannister-1920.jpg?w=1200'
  },
  {
    name: 'Cersei Lannister',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/cersei-lannister-1920.jpg?w=1200'
  },
  {
    name: 'Catelyn Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/catelyn-stark-1920.jpg?w=1200'
  },
  {
    name: 'Jaime Lannister',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/jamie-lannister-1920.jpg?w=960'
  },
  {
    name: 'Daenerys Targaryen',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/daenarys-1920.jpg?w=960'
  },
  {
    name: 'Viserys Targaryen',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/viserys-targaryen-1920.jpg?w=960'
  },
  {
    name: 'Jon Snow',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/john-snow-1920.jpg?w=960'
  },
  {
    name: 'Robb Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/robert-stark-1920.jpg?w=960'
  },
  {
    name: 'Sansa Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/sansa-stark-1920.jpg?w=960'
  },
  {
    name: 'Arya Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/arya-stark-1920.jpg?w=960'
  },
  {
    name: 'Brandon Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/bran-stark-1920.jpg?w=960'
  },
  {
    name: 'Rickon Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/rickon-stark-1920.jpg?w=960'
  },
  {
    name: 'Joffrey Baratheon',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/joffrey-baratheon-1920.jpg?w=960'
  },
  {
    name: 'Jorah Mormont',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/jorah-mormont-1920.jpg?w=960'
  },
  {
    name: 'Theon Greyjoy',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/theon-greyjoy-1920.jpg?w=960'
  },
  {
    name: 'Samwell Tarly',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/samwell-1920.jpg?w=960'
  },
  {
    name: 'Renly Baratheon',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/renly-baratheon-1920.jpg?w=960'
  },
  {
    name: 'Ros',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/ros-1920.jpg?w=960'
  },
  {
    name: 'Jeor Mormont',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/jeor-mormont-1920.jpg?w=960'
  },
  {
    name: 'Gendry',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/gendry-1920.jpg?w=960'
  },
  {
    name: 'Lysa Arryn',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/lysa-arryn-1920.jpg?w=960'
  },
  {
    name: 'Robin Arryn',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/robyn-arryn-1920.jpg?w=960'
  },
  {
    name: 'Bronn',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/bronn-1920.jpg?w=960'
  },
  {
    name: 'Grand Maester Pycelle',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/maester-pycelle-1920.jpg?w=960'
  },
  {
    name: 'Varys',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/maetser-varys-1920.jpg?w=960'
  },
  {
    name: 'Loras Tyrell',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/loras-tyrell-1920.jpg?w=960'
  },
  {
    name: 'Shae',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/shae-1920.jpg?w=960'
  },
  {
    name: 'Hodor',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/hodor-1920.jpg?w=960'
  },
  {
    name: 'Lancel Lannister',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/lancel-lannister-1920.jpg?w=960'
  },
  {
    name: 'Maester Luwin',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/maester-luwin-1920.jpg?w=960'
  },
  {
    name: 'Alliser Thorne',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/allister-thorne-1920.jpg?w=960'
  },
  {
    name: 'Osha',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/osha-1920.jpg?w=960'
  },
  {
    name: 'Maester Aemon',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/aemon-targaryen-1920.jpg?w=960'
  },
  {
    name: 'Talisa Stark',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/talisa-stark-1920.jpg?w=960'
  },
  {
    name: 'Brienne of Tarth',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/brienne-of-tarth-1920.jpg?w=960'
  },
  {
    name: 'Davos Seaworth',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/davos-seaworth-1920.jpg?w=960'
  },
  {
    name: 'Tywin Lannister',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/tywin-lannister-1920.jpg?w=960'
  },
  {
    name: 'Stannis Baratheon',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/stannis-baratheon-1920.jpg?w=960'
  },
  {
    name: 'Margaery Tyrell',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/margarey-tyrell-1920.jpg?w=960'
  },
  {
    name: 'Ygritte',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/ygritte-1920.jpg?w=960'
  },
  {
    name: 'Roose Bolton',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/roose-bolton-1920.jpg?w=960'
  },
  {
    name: 'Balon Greyjoy',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/balon-greyjoy-1920.jpg?w=960'
  },
  {
    name: 'Gilly',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s6/gilly-1920.jpg?w=960'
  },
  {
    name: 'Podrick Payne',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/podrick-payne-1920.jpg?w=960'
  },
  {
    name: "Jaqen H'ghar",
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/jaqen-hghar-1920.jpg?w=960'
  },
  {
    name: 'Melisandre',
    img: 'https://static.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/melisandre-1920.jpg?w=960'
  }
];
